import React from "react";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";

const IadePolitikasiPage = () => {
  return (
    <>
      {/* ScrollToTop */}
      <ScrollToTop smooth color="#37B24D" />

      {/* HeaderOne */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"İade Politikası"} />

      {/* Ana İçerik Bölümü */}
      <section className="contracts py-80">
        <div className="container container-lg">
          <div className="row">
            <div className="col-12">
              {/* Sayfa Başlığı */}
              <div className="text-center mb-48">
                <span className="text-main-600 fw-semibold mb-8 d-block">
                  YASAL DÜZENLEMELER
                </span>
                <h2 className="mb-16" style={{ fontSize: '36px', lineHeight: '1.2' }}>
                  İade ve Cayma Hakkı <br />
                  <span className="text-main-600">Politikası</span>
                </h2>
                <p className="text-neutral-600 mb-0" style={{ fontSize: '16px', maxWidth: '600px', margin: '0 auto' }}>
                  Gümüş Pestil olarak müşterilerimizin haklarını korumak ve şeffaf bir hizmet sunmak için 
                  iade ve cayma hakkı politikamızı burada bulabilirsiniz.
                </p>
              </div>

              {/* İade Politikası İçeriği */}
              <div className="row">
                <div className="col-12">
                  <div className="contract-card border border-gray-100 rounded-16 p-32 mb-24 bg-white shadow-sm">
                    <div className="d-flex align-items-center gap-16 mb-24">
                      <div className="w-56 h-56 flex-center rounded-circle bg-main-50 flex-shrink-0">
                        <i className="ph-fill ph-arrow-counter-clockwise text-main-600 text-2xl"></i>
                      </div>
                      <div>
                        <h4 className="mb-4 text-gray-900">İade ve Cayma Hakkı Politikası</h4>
                        <p className="text-gray-600 mb-0">İade süreçleri ve cayma hakkı koşulları</p>
                      </div>
                    </div>
                    
                    <div className="contract-content">
                      <div className="bg-gray-50 rounded-12 p-24">
                        <h3 className="text-center mb-32 text-gray-900">İADE VE CAYMA HAKKI POLİTİKASI</h3>
                        
                        <div className="mb-24">
                          <p className="text-gray-700 mb-0">
                            İşbu İade ve Cayma Hakkı Politikası, SARAÇ GIDA YAKACAK NAKLİYE OTO ALIM SATIMI KIRTASİYE HAYVAN Limited Şirketi (Bundan sonra "SATICI" veya "Gümüş Pestil" olarak anılacaktır) tarafından işletilen www.gumuspestil.com internet sitesinden alışveriş yapan ALICI'ların iade süreçlerini ve cayma hakkı koşullarını düzenlemektedir.
                          </p>
                        </div>

                        {/* 1. Cayma Hakkının İstisnaları */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-scale text-main-600"></i>
                            1. CAYMA HAKKININ İSTİSNALARI (GIDA ÜRÜNLERİ)
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <p className="text-gray-700 mb-16">
                              6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği'nin 15. Maddesi ("Cayma Hakkının İstisnaları") uyarınca;
                            </p>
                            <p className="text-gray-700 mb-16 fw-semibold">
                              "Taraflarca aksi kararlaştırılmadıkça, tüketici aşağıdaki sözleşmelerde cayma hakkını kullanamaz: ... c) Çabuk bozulabilen veya son kullanma tarihi geçebilecek malların teslimine ilişkin sözleşmeler. ç) Tesliminden sonra ambalaj, bant, mühür, paket gibi koruyucu unsurları açılmış olan mallardan; iadesi sağlık ve hijyen açısından uygun olmayanların teslimine ilişkin sözleşmeler."
                            </p>
                            <p className="text-gray-700 mb-0">
                              SATICI tarafından satışı yapılan ürünler (pestil, köme, vb.) gıda ürünü olup, "çabuk bozulabilen" ve "sağlık/hijyen açısından hassas" ürünler kategorisindedir.
                            </p>
                            <p className="text-gray-700 mb-0 mt-16">
                              Bu yasal düzenleme gereği, hatalı veya ayıplı ürün durumları dışında, ürünlerimizin teslim alındıktan sonra iade edilmesi veya "cayma hakkı" kullanılması mümkün değildir.
                            </p>
                          </div>
                        </div>

                        {/* 2. İade Koşulları */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-check-circle text-main-600"></i>
                            2. İADE KOŞULLARI (AYIPLI, HASARLI VEYA YANLIŞ ÜRÜN)
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <p className="text-gray-700 mb-16">
                              ALICI'nın yasal iade hakkı, yalnızca aşağıda belirtilen durumlarda ve belirtilen koşullara uyulması halinde geçerlidir:
                            </p>
                            <ul className="text-gray-700 mb-0">
                              <li className="mb-8">Ürünün hasarlı, ezilmiş veya bozulmuş olması (Kargodan kaynaklı hasarlar hariç, bkz. Madde 4).</li>
                              <li className="mb-8">Sipariş edilen üründen farklı bir ürün gönderilmesi.</li>
                              <li className="mb-8">Ürünün eksik gramajlı veya eksik adetli gönderilmesi.</li>
                              <li className="mb-0">Ürünün son kullanma tarihinin geçmiş olması.</li>
                            </ul>
                          </div>
                        </div>

                        {/* 3. İade Süreci */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-arrows-clockwise text-main-600"></i>
                            3. İADE SÜRECİ
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <p className="text-gray-700 mb-16">
                              ALICI, yukarıda Madde 2'de belirtilen durumlardan birini tespit etmesi halinde, ürünü teslim aldığı tarihten itibaren 7 (yedi) gün içerisinde SATICI'ya bildirimde bulunmakla yükümlüdür.
                            </p>
                            
                            <div className="mb-16">
                              <h6 className="mb-8 text-gray-900 fw-semibold">
                                Bildirim:
                              </h6>
                              <p className="text-gray-700 mb-0">
                                ALICI, durumu açıkça belirten bir e-postayı, sipariş numarası ve kusuru net bir şekilde gösteren fotoğraf veya video kanıtlarıyla birlikte fabrika@gumuspestil.com e-posta adresine göndermeli veya +90 539 483 8998 numaralı telefondan SATICI'ya ulaşmalıdır.
                              </p>
                            </div>

                            <div className="mb-16">
                              <h6 className="mb-8 text-gray-900 fw-semibold">
                                Değerlendirme:
                              </h6>
                              <p className="text-gray-700 mb-0">
                                SATICI, yapılan bildirimi ve sunulan kanıtları inceleyerek ALICI'ya en kısa sürede dönüş yapacaktır.
                              </p>
                            </div>

                            <div className="mb-16">
                              <h6 className="mb-8 text-gray-900 fw-semibold">
                                Onay ve İade:
                              </h6>
                              <p className="text-gray-700 mb-8">
                                İade talebi SATICI tarafından onaylanırsa, ALICI'ya ürünü hangi kargo firması ile ve nasıl göndereceği bilgisi verilecektir. İade edilecek ürünlerin, SATICI'nın belirttiği anlaşmalı kargo firması aracılığıyla gönderilmesi tercih edilir. Farklı bir kargo firması kullanılması durumunda, kargo ücreti ALICI tarafından karşılanacaktır.
                              </p>
                              <p className="text-gray-700 mb-0">
                                ALICI, ürünü kendi seçtiği kargo firması ile de gönderebilir; ancak bu durumda kargo ücreti ALICI tarafından karşılanır.
                              </p>
                            </div>

                            <div className="mb-0">
                              <h6 className="mb-8 text-gray-900 fw-semibold">
                                Ürünlerin Durumu:
                              </h6>
                              <p className="text-gray-700 mb-0">
                                İade edilecek ayıplı ürünün, SATICI'ya ulaştırılana kadar ALICI tarafından uygun koşullarda (serin, kuru, güneş almayan yer) muhafaza edilmesi gerekmektedir.
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* 4. Kargodan Kaynaklanan Hasaralar */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-truck text-main-600"></i>
                            4. KARGODAN KAYNAKLANAN HASARLAR
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <p className="text-gray-700 mb-16">
                              ALICI, ürünü teslim aldığı anda kargo paketini kontrol etmekle yükümlüdür. Kargo paketinde herhangi bir ezilme, yırtılma veya ıslaklık gibi bariz bir hasar tespit edilmesi durumunda, ALICI:
                            </p>
                            <ul className="text-gray-700 mb-16">
                              <li className="mb-8">Ürünü teslim almamalıdır.</li>
                              <li className="mb-8">Kargo görevlisine derhal "Hasar Tespit Tutanağı" tutturmalıdır.</li>
                              <li className="mb-0">Bu tutanakla birlikte durumu derhal SATICI'ya (fabrika@gumuspestil.com) bildirmelidir.</li>
                            </ul>
                            <p className="text-gray-700 mb-0">
                              Teslim alındıktan ve kargo görevlisi ayrıldıktan sonra fark edilen ve kargodan kaynaklandığı iddia edilen hasarlardan SATICI sorumlu tutulamaz. Ancak, teslim alındıktan sonra makul bir süre içinde (7 gün) tespit edilen ve kargodan kaynaklandığı açıkça belli olan hasarlar için ALICI'nın bildirim hakkı saklıdır.
                            </p>
                          </div>
                        </div>

                        {/* 5. Geri Ödeme */}
                        <div className="mb-0">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-currency-try text-main-600"></i>
                            5. GERİ ÖDEME
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <p className="text-gray-700 mb-16">
                              İade talebi onaylanan ve ürünleri SATICI'ya geri ulaşan ALICI için geri ödeme süreci başlatılır.
                            </p>
                            <p className="text-gray-700 mb-16">
                              İade edilen ürün SATICI'ya ulaştıktan ve incelendikten sonra, iade koşullarına uygunluğu teyit edilirse, ürün bedeli (ve eğer tamamı iade edildiyse kargo ücreti) ALICI'nın sipariş sırasında kullandığı ödeme yöntemine göre (Kredi Kartı, Havale/EFT) iade edilir.
                            </p>
                            <p className="text-gray-700 mb-0">
                              Yasal geri ödeme süresi, ürünün SATICI'ya ulaştığı tarihten itibaren 14 (on dört) gündür. Kredi kartı iadelerinin ALICI'nın hesabına yansıması, bankaların iç süreçlerine bağlı olarak 2-7 iş günü sürebilir.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default IadePolitikasiPage;

